import XEUtils from 'xe-utils';

export default {
  data() {
    return {
      currentRowInfo: {}, //物贸  当前行信息
    };
  },
  methods: {
    async changeCurrentRowInfo(row) {
      let checkLinesRefStatus = await this.$refs?.rowDetailTableRef?.validAllEvent(true);
      console.log('this.$refs.rowInfo', this.$refs.rowInfo);
      if (checkLinesRefStatus) {
        this.$refs.rowInfo.$refs.ruleTable.setCurrentRow(this.currentRowInfo);
        return;
      }
      this.currentRowInfo = row;
    },
    // 模板导入后更新当前行明细
    changeRowDetail() {
      let fullTableData = this.$refs.rowInfo.getTableData();
      if (this.currentRowInfo != null && JSON.stringify(this.currentRowInfo) == '{}') {
        this.currentRowInfo = fullTableData.find(
          (item) =>
            item?.receivableSettlementLineId == this.currentRowInfo?.receivableSettlementLineId
        );
        this.updateRowDetail(
          this.currentRowInfo?.receivableSettlementLineId,
          this.currentRowInfo?.detailExtendList
        );
      } else {
        this.currentRowInfo = fullTableData[0];
        this.updateRowDetail(
          this.currentRowInfo?.receivableSettlementLineId,
          this.currentRowInfo?.detailExtendList
        );
      }
    },
    rowDetailInsert(rowInfoId, rowData) {
      let fullTableData = this.$refs.rowInfo.getTableData();
      console.log('明细插入一行修改数据', fullTableData, 'rowData', rowData);
      fullTableData.forEach((item) => {
        console.log('rowInfoId', item.receivableSettlementLineId, rowInfoId);
        if (item.receivableSettlementLineId == rowInfoId) {
          if (item.detailExtendList != null) {
            item.detailExtendList.unshift(rowData);
          } else {
            item.detailExtendList = [rowData];
          }
        }
      });
      this.$refs.rowInfo.tableData = fullTableData;
    },
    deleteRowDetail(rowInfoId, idList) {
      let fullTableData = this.$refs.rowInfo.getTableData();
      fullTableData.forEach((item) => {
        if (item.receivableSettlementLineId == rowInfoId) {
          item.detailExtendList = item.detailExtendList.filter(
            (item) => !idList.includes(item._XID)
          );
          this.updateRowDetail(rowInfoId, item.detailExtendList);
        }
      });
    },
    // 更新数据修改行信息
    updateRowDetail(rowInfoId, detailExtendList) {
      let rowDetailTable = [];
      if (detailExtendList != null && detailExtendList.length > 0) {
        rowDetailTable = detailExtendList;
      } else {
        rowDetailTable = this.$refs?.rowDetailTableRef.getTableData();
      }
      console.log('明细行信息改变了', rowInfoId, rowDetailTable);

      let fullTableData = this.$refs.rowInfo.getTableData();
      let sumInvoiceAmount = 0; //开票总金额
      let sumExcludedTaxAmount = 0; //不含税金额
      // let sumTaxAmount = 0;//税额
      // let sumTaxAccountedAmount = 0;//本币税额
      // let sumExcludedTaxAccountedAmount = 0;//本币不含税金额
      // let sumInvoiceAccountedAmount = 0;//本币总金额
      // 税额 = 开票总金额-不含税金额
      fullTableData.forEach((item) => {
        let totalInvoiceAmount = XEUtils.calSum(item.detailExtendList, 'invoiceAmount'); //开票总金额
        let totalExcludedTaxAmount = XEUtils.calSum(item.detailExtendList, 'excludedTaxAmount'); //不含税金额
        let invoiceQuantity = XEUtils.calSum(item.detailExtendList, 'invoiceQuantity')?.toFixed(8); //数量
        let totalTaxAmount = (totalInvoiceAmount - totalExcludedTaxAmount)?.toFixed(2); //税额
        let totalTaxAccountedAmount = (
          (totalInvoiceAmount - totalExcludedTaxAmount) *
          this.$refs.invoiceInfo.formData.exchangeRate
        ).toFixed(2); //本币税额
        let totalInvoiceAccountedAmount = (
          totalInvoiceAmount * this.$refs.invoiceInfo.formData.exchangeRate
        ).toFixed(2); //本币总金额
        let totalExcludedTaxAccountedAmount = (
          totalExcludedTaxAmount * this.$refs.invoiceInfo.formData.exchangeRate
        ).toFixed(2); //本币不含税金额

        item.taxAccountedAmount = totalTaxAccountedAmount; //本币税额
        item.excludedTaxAccountedAmount = totalExcludedTaxAccountedAmount; //本币不含税金额
        item.invoiceAccountedAmount = totalInvoiceAccountedAmount; //本币含税金额
        item.taxAmount = totalTaxAmount; //税额
        item.excludedTaxAmount = totalExcludedTaxAmount; //不含税金额
        item.invoiceQuantity = invoiceQuantity; //数量
        item.invoiceAmount = totalInvoiceAmount; //含税总金额
        item.invoiceUnitPrice = (totalInvoiceAmount / invoiceQuantity)?.toFixed(8); //含税单价

        sumInvoiceAmount += totalInvoiceAmount;
        sumExcludedTaxAmount += totalExcludedTaxAmount;
        if (item.receivableSettlementLineId == rowInfoId) {
          if (rowDetailTable != null && rowDetailTable.length) {
            item.detailExtendList = rowDetailTable;
            // const invoiceUnitList = rowDetailTable
            //   .map((item) => item.invoiceUnit)
            //   ?.filter((item) => item != ''); //单位
            // const invoiceDescList = rowDetailTable
            //   .map((item) => item.invoiceDesc)
            //   ?.filter((item) => item != ''); //开票描述
            // const productSpecificationModelList = rowDetailTable
            //   .map((item) => item.productSpecificationModel)
            //   ?.filter((item) => item != ''); //规格
            // const settlementQuantityList = rowDetailTable
            //   .map((item) => item.settlementQuantity)
            //   ?.filter((item) => item != ''); //数量
            // const invoiceUnitPriceList = rowDetailTable
            //   .map((item) => item.invoiceUnitPrice)
            //   ?.filter((item) => item != ''); //单价
            // const excludedTaxAmountList = rowDetailTable
            //   .map((item) => item.excludedTaxAmount)
            //   ?.filter((item) => item != ''); //不含税金额
            // const invoiceAmountList = rowDetailTable
            //   .map((item) => item.invoiceAmount)
            //   ?.filter((item) => item != ''); //含税金额
            const taxRateList = rowDetailTable
              .map((item) => item.taxRate)
              ?.filter((item, index, arr) => arr.indexOf(item) === index); //税率

            console.log('改变的行是', item);
            console.log('=========taxRateList=====', taxRateList);
            // if (invoiceUnitList.length == 1) {
            //   console.log('invoiceUnitList', invoiceUnitList);
            //   item.invoiceUnit = invoiceUnitList[0] || '';
            // } else {
            //   item.invoiceUnit = '';
            // }
            // if (invoiceDescList.length == 1) {
            //   item.invoiceDesc = invoiceDescList[0] || '';
            // } else {
            //   item.invoiceDesc = '';
            // }
            // if (productSpecificationModelList.length == 1) {
            //   item.productSpecificationModel = productSpecificationModelList[0] || '';
            // } else {
            //   item.productSpecificationModel = '';
            // }
            // if (invoiceUnitPriceList.length == 1) {
            //   item.invoiceUnitPrice = invoiceUnitPriceList[0] || '';
            // } else {
            //   item.invoiceUnitPrice = '';
            // }
            if (taxRateList.length == 1) {
              item.taxRate = taxRateList[0] || 0;
            } else {
              item.taxRate = 0;
            }
            // 数量
            // if (
            //   invoiceUnitList.length == 1 &&
            //   invoiceUnitPriceList.length == 1 &&
            //   settlementQuantityList.length > 0
            // ) {
            //   let total = this.sumNum(settlementQuantityList);
            //   item.settlementQuantity = total;
            // } else {
            //   item.settlementQuantity == '0';
            // }
            // // 不含税金额
            // if (excludedTaxAmountList.length > 0) {
            //   let total = this.sumNum(excludedTaxAmountList);
            //   item.excludedTaxAmount = total;
            // } else {
            //   item.excludedTaxAmoun = '0';
            // }
            // //含税金额
            // if (invoiceAmountList.length > 0) {
            //   let total = this.sumNum(invoiceAmountList);
            //   item.invoiceAmount = total;
            // } else {
            //   item.invoiceAmount = '0';
            // }
          }
        }
      });
      this.$refs.invoiceInfo.formData.invoiceAmount = sumInvoiceAmount?.toFixed(2);
      this.$refs.invoiceInfo.formData.excludedTaxAmount = sumExcludedTaxAmount?.toFixed(2);
      this.$refs.invoiceInfo.formData.taxAmount = (
        sumInvoiceAmount - sumExcludedTaxAmount
      )?.toFixed(2); //税额
      this.$refs.invoiceInfo.formData.taxAccountedAmount = (
        (sumInvoiceAmount - sumExcludedTaxAmount) *
        this.$refs.invoiceInfo.formData.exchangeRate
      ).toFixed(2);
      this.$refs.invoiceInfo.formData.invoiceAccountedAmount = (
        sumInvoiceAmount * this.$refs.invoiceInfo.formData.exchangeRate
      ).toFixed(2);
      this.$refs.invoiceInfo.formData.excludedTaxAccountedAmount = (
        sumExcludedTaxAmount * this.$refs.invoiceInfo.formData.exchangeRate
      ).toFixed(2);
      this.$refs.rowInfo.$refs['ruleTable'].updateFooter();
    },
    sumNum(list) {
      let count = 0;
      list.forEach((item) => {
        count += +item;
      });
      return count > 0 ? count.toFixed(2) : 0;
    },
  },
};
